import { api } from '@/lib/api'
import type { CompanySettings } from '@/types/company.types'

export const companySettingsService = {
  get(companyId: string): Promise<CompanySettings> {
    return api.get<CompanySettings>(`/companies/${companyId}/settings`)
  },

  update(companyId: string, payload: Partial<CompanySettings>): Promise<CompanySettings> {
    return api.put<CompanySettings>(`/companies/${companyId}/settings`, payload)
  },
}
